import { useContext } from 'react';

import { EffectiveGroupSubscriptionsContext } from './EffectiveGroupSubscriptionsContext';

export const useEffectiveGroupSubscriptionsContext = () => {
  const context = useContext(EffectiveGroupSubscriptionsContext);
  if (!context) {
    throw new Error('useEffectiveGroupSubscriptionsContext must be used within an EffectiveGroupSubscriptionsProvider');
  }
  return context;
};
